module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.to_editor === 'true') ? _c('ul', {
    staticClass: "docCreation"
  }, _vm._l((_vm.types), function(t) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": '/docs/edit/false/' + t._id
      }
    }, [_vm._v(_vm._s(t.name))])], 1)
  }), 0) : _c('ul', {
    staticClass: "docCreation"
  }, _vm._l((_vm.types), function(t) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": '/docs/make/' + t._id + '/' + _vm.matter_id
      }
    }, [_vm._v(_vm._s(t.name))])], 1)
  }), 0), _vm._v(" "), (_vm.to_editor === 'true') ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "left",
      "clear": "both"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/docs/edit/true/' + _vm.matter_type
    }
  }, [_c('i', {
    staticClass: "icon icon-plus"
  }), _vm._v(" New")])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-372c699e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/chooseDocType.vue
// module id = 489
// module chunks = 1